import { isAcuityScoreApprover, isAllowed42CFRP2Email } from "../../helpers/predicates";
import type { PermissionConfig, PermissionKey } from "../../types";

export const ACUITY_PERMISSIONS = {
  acuityScoreApprove: {
    allowIf: isAcuityScoreApprover,
    description: "Approve/reject acuity update requests",
    excludedRoles: [
      "admin:admin",
      "admin:billing_partner",
      "admin:customer_success_executive",
      "admin:customer_success_manager",
      "provider:behavioral",
      "provider:case_manager",
      "provider:pcp",
      "provider:peer",
      "provider:prescribe",
      "system:workflow",
    ],
  },
  acuityScoreHistory: {
    allowIf: isAllowed42CFRP2Email,
    description: "View acuity score change history",
    excludedRoles: ["provider:pcp"], // provider:pcp covers both PCP and Care Manager (backend mapping)
  },
  acuityScorePendingStatus: {
    description: "View pending acuity score change status",
    excludedRoles: ["provider:pcp"], // provider:pcp covers both PCP and Care Manager (backend mapping)
  },
  acuityScoreReport: {
    description: "Report an acuity score change request",
    // provider:pcp covers both PCP and Care Manager (backend mapping)
    // admin:customer_success_manager is read-only on patient charts and not
    // involved in the acuity changing process — see ASD-1378 / #5364
    excludedRoles: ["provider:pcp", "admin:customer_success_manager"],
  },
} satisfies Partial<Record<PermissionKey, PermissionConfig>>;
